export const MM_MIN_MINUTES = 1
export const MM_DEFAULT_MINUTES = 10
export const MM_PRESETS = [10, 30, 60, 120, 240]

export function clampDurationMinutes(value) {
    const n = Math.floor(Number(value))
    if (!Number.isFinite(n)) return MM_DEFAULT_MINUTES
    if (n < MM_MIN_MINUTES) return MM_MIN_MINUTES
    return n
}

export function formatDurationLabel(minutes) {
    if (minutes % 60 === 0) return `${minutes / 60}h`
    if (minutes < 60) return `${minutes}m`
    return `${Math.floor(minutes / 60)}h ${minutes % 60}m`
}
